import React from "react";

const BulkRegularization = () => {
    return <div>BulkRegularization</div>;
};

export default BulkRegularization;